import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';

const formName = FormsEnum.TravelCheckoutForm;

const insurantAddressDetails = {
  travelCheckoutInsurantHomeAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.TravelCheckoutInsurantZipCode,
      formName
    );
  },
};

export default insurantAddressDetails;
